import endpoint from "@/api/endpoint";

export default {
    addGadget(token) {
        return window.axios.post(endpoint + '/api/user/gadget', {token, name: 'web'});
    },

}
